module.exports = __webpack_public_path__ + "static/media/ico-sodexo.47d72e26.svg";